import { AccuracyType } from 'api/query/shared/accuracy-type.enum';
import { useUser } from 'providers/user/use-user';
import React, { memo, useEffect, useState } from 'react';
import { LinkageTagProps } from './linkage-tag-props';
import './linkage-tag.scss';

export const LinkageTag: React.FC<LinkageTagProps> = memo((props) => {
  const { accuracyType, accuracy } = props;
  const [show, setShow] = useState<boolean>(false);
  const { isAdmin } = useUser();

  useEffect(() => {
    const display = isAdmin && accuracyType === AccuracyType.NotLinked && accuracy !== '';
    if (display) {
      setShow(display);
    }
    setShow(display);
  }, [isAdmin, accuracyType, accuracy]);

  return (
    <>
      {show && (
        <span className="sg-linkage-tag highlight--red">
          Linkage
        </span>
      )}
    </>
  );
});
